export const GOOGLE_ANALYTICS_ID = 'UA-21170686-8';

export const GOOGLE_CLIENT_ID =
  '685797762223-edandm45c2023v4bvcqanggdkhgb3ims.apps.googleusercontent.com';
